'use strict';
angular.module('editctrInitBtnModule', []).factory('initeditctrBtnsService', [
    '$q',
    'trsHttpService',
    'publicToolService',
    function ($q, trsHttpService, publicToolService) {

        /**
         * [transformRights description]
         * @param   {[type]}  _arrary  [_arrary description]
         * @param   {[type]}  btns     [btns description]
         * @return  {[type]}           [return description]
         */
        function transformRights(_arrary, btns){
            let tempBtn;
            let btnStatus = [];
            let rightStatus = btns;
            if (angular.isArray(_arrary)) {
                for (var i = 0; i < _arrary.length; i++) {
                    tempBtn = _arrary[i];
                    if (angular.isArray(rightStatus[tempBtn.RIGHTINDEX])) {
                        angular.forEach(rightStatus[tempBtn.RIGHTINDEX], function (_value, _key) {
                            var tpBtn = _value;
                            tpBtn.RIGHTINDEX = _value.RIGHTINDEX;
                            tpBtn.OPERDESC = _value.OPERDESC;
                            tpBtn.OPERFUN = _value.OPERFUN;
                            btnStatus.push(tpBtn);
                        });
                    } else {
                        if (angular.isUndefined(rightStatus[tempBtn.RIGHTINDEX])) {
                            continue;
                        }
                        tempBtn.OPERDESC = rightStatus[tempBtn.RIGHTINDEX].OPERDESC;
                        tempBtn.OPERFUN = rightStatus[tempBtn.RIGHTINDEX].OPERFUN;
                        btnStatus.push(tempBtn);
                    }
                }
                return btnStatus;
            }
        }
        return {
            initData: function (metaDataId, ChnlDocId) {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'findDocStatusByMetadataId',
                    MetaDataId: metaDataId,
                    ChnlDocId: ChnlDocId,
                };
                return trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'post');
            },
            initIwoData: function (ModalName) {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'findMyOperRightByModal',
                    ModalName: ModalName,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post');
            },
            initDepartmentData: function (departmentDocId) {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperkeyOfDeptmentalDoc',
                    DepartmentalDocId: departmentDocId,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post');
            },

            /**
             * [ModalName description]
             * @param   {[type]}  ModalName  [ModalName description]
             * @param   {[type]}  siteid     [siteid description]
             * @param   {[type]}  channelid  [channelid description]
             * @return  {[type]}             [return description]
             */
            initNewsData: function (ModalName, siteid, channelid) {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryPaperOperRightOfModal',
                    ModalName: ModalName,
                    SiteId: siteid,
                    Channelid: channelid
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post');
            },
            initWebsiteData: function (ChannelId, Classify) {
                var params = {
                    // serviceid: 'mlf_metadataright',
                    // methodname: 'queryOperKeyByBaseChannel',
                    // ChannelId: ChannelId,
                    // StatusType: StatusType,
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    ChannelId: ChannelId,
                    // StatusType: methodname,
                    Classify: Classify,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post');
            },
            initAppData: function (ChannelId, Classify) {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    Classify: Classify,
                    ChannelId: ChannelId,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post');
            },
            initWechatData: function (channelid, classify) {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    Classify: classify,
                    ChannelId: channelid,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post');
            },
            initTvData: function (channelid, classify) {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    Classify: classify,
                    ChannelId: channelid,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post');
            },

            /**
             * [initBtns description] 初始化按钮
             * @param   {[type]}  _arrary  [_arrary description]
             * @param   {[type]}  btns     [btns description]
             * @return  {[type]}           [return description]
             */
            initBtns: function (_arrary, btns) {
                let defer = $q.defer();
                publicToolService.getModeconfiguration('IM').then((config) => {
                    let btnStatus = transformRights(_arrary, btns);
                    if (config && config.sendSwitch === 'on') {
                        // 因为发送按钮不基于权限控制，只根据配置中心来决定，在这里添加可以便于修改每个编辑页面
                        btnStatus.push({
                            OPERDESC: '发送',
                            OPERFUN: 'sendMessage',
                            OPERNAME: 'global.sendmessage',
                            RIGHTINDEX: '-1',
                        });
                    }
                    defer.resolve(btnStatus);
                }, () => {
                    let btnStatus = transformRights(_arrary, btns);
                    defer.resolve(btnStatus);
                });
                return defer.promise;
            },
        };
    },
]);
